import styles from "./ResourceBrowserSearchResults.module.css";

import ResourceTile from "../ResourceTile/ResourceTile";

function ResourceBrowserSearchResults({ results, searchValue }) {
    function ResultsBody() {
        if (results.length > 0) {
            // results found
            return <ResultsFoundBody />;
        } else if (searchValue.length > 0) {
            // no results found for a query
            return <NoResultsBody />;
        } else {
            // no query
            return <NoQueryBody />;
        }
    }

    function ResultsFoundBody() {
        return results.map((result) => (
            <ResourceTile {...result} key={result.name} />
        ));
    }

    function NoResultsBody() {
        return (
            <div className={styles.no_results_container}>
                <img
                    src="/images/no-search-results-icon.png"
                    alt="No search results"
                    draggable={false}
                />
                <div className={styles.message}>
                    No results found for{" "}
                    <span style={{ color: "var(--keel-orange)" }}>
                        {searchValue}
                    </span>
                </div>
            </div>
        );
    }

    function NoQueryBody() {
        return (
            <div className={styles.no_results_container}>
                <img
                    src="/images/no-search-results-icon.png"
                    alt="No search results"
                    draggable={false}
                />
                <div className={styles.message}>Search for a resource</div>
            </div>
        );
    }

    return <ResultsBody />;
}

export default ResourceBrowserSearchResults;
